import styled from 'styled-components'

export const LabelInput = styled.label`
  margin-bottom: 10px;
  font-size: var(--font-small);
  color: var(--white);
  font-weight: 700;
`
